import { render, staticRenderFns } from "./SubscribersList.vue?vue&type=template&id=6c9784b7&lang=pug"
import script from "./SubscribersList.vue?vue&type=script&lang=ts"
export * from "./SubscribersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports